import { useEffect, useState } from "react";
import { Coins, Loader2, ChevronDown, TrendingUp } from "lucide-react";
import { api } from "../../lib/api";
import { fcfa } from "../../lib/format";

export function VendeurCommissionCard() {
  const [data, setData] = useState(null);
  const [showDetail, setShowDetail] = useState(false);

  useEffect(() => { api.get("/vendeur/commissions/me").then(({ data }) => setData(data)).catch(() => setData(false)); }, []);

  if (data === null) return <div className="bg-white border border-brand-line rounded-2xl p-6 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-brand" /></div>;
  if (data === false) return null;

  return (
    <div data-testid="vendeur-commission-card" className="bg-white border border-brand-line rounded-2xl p-5 sm:p-6">
      <div className="flex items-center gap-2">
        <span className="w-9 h-9 rounded-xl bg-amber-100 text-amber-700 flex items-center justify-center"><Coins className="w-5 h-5" /></span>
        <div>
          <h2 className="font-heading font-bold text-brand-ink">Mes commissions</h2>
          <p className="text-xs text-brand-muted">{data.rate}% sur mes ventes payées.</p>
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mt-5">
        <div className="rounded-xl bg-amber-50 border border-amber-100 p-4" data-testid="commission-due">
          <p className="text-xs text-amber-800">À recevoir (non payé)</p>
          <p className="font-heading font-black text-xl text-amber-900 mt-1">{fcfa(data.total_due)}</p>
        </div>
        <div className="rounded-xl bg-brand-cream border border-brand-line p-4">
          <p className="text-xs text-brand-muted">Cette semaine</p>
          <p className="font-heading font-black text-xl text-brand-ink mt-1">{fcfa(data.week)}</p>
        </div>
        <div className="rounded-xl bg-brand-cream border border-brand-line p-4">
          <p className="text-xs text-brand-muted">Ce mois</p>
          <p className="font-heading font-black text-xl text-brand-ink mt-1">{fcfa(data.month)}</p>
        </div>
        <div className="rounded-xl bg-green-50 border border-green-100 p-4">
          <p className="text-xs text-green-800">Déjà payé</p>
          <p className="font-heading font-black text-xl text-green-900 mt-1">{fcfa(data.total_paid)}</p>
        </div>
      </div>

      <button onClick={() => setShowDetail((v) => !v)} data-testid="commission-detail-toggle" className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-brand hover:gap-2 transition-all">
        Détail de mes ventes <ChevronDown className={`w-4 h-4 transition-transform ${showDetail ? "rotate-180" : ""}`} />
      </button>

      {showDetail && (
        <div className="mt-3 space-y-2" data-testid="commission-detail">
          {data.recent.length === 0 ? <p className="text-sm text-brand-muted">Aucune vente payée pour l'instant.</p>
            : data.recent.map((o) => (
              <div key={o.order_number} className="flex items-center justify-between border border-brand-line rounded-xl px-4 py-2.5">
                <div className="text-sm">
                  <span className="font-semibold text-brand-ink">{o.order_number}</span>
                  <span className="text-brand-muted ml-2">{new Date(o.created_at).toLocaleDateString("fr-FR")}</span>
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-sm font-bold text-brand"><TrendingUp className="w-3.5 h-3.5 inline mr-1" />{fcfa(o.commission)}</span>
                  <span className={`text-[11px] font-semibold rounded-full px-2 py-0.5 ${o.paid ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>{o.paid ? "payé" : "en attente"}</span>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
